// Seed data only, not a closed catalog: HeavyDutyMachineryForm/EditForm's
// ManufacturerBrand/ModelName fields stay free text (an unlisted host's rig
// must never be blocked from publishing) -- this just powers an
// AutoComplete's suggestions, scoped per Category so picking "Excavator"
// doesn't suggest scissor-lift brands. One entry per (category, brand) pair
// rather than a global brand -> models map, since the same brand (e.g.
// Caterpillar) makes different model lines for different categories.
export interface MachineryBrandSeed {
  category: string;
  brand: string;
  models: string[];
}

export const MACHINERY_BRANDS_SEED: MachineryBrandSeed[] = [
  // Excavator
  { category: 'excavadora-de-cadenas', brand: 'Caterpillar', models: ['301.7', '320', '330', '336'] },
  { category: 'excavadora-de-cadenas', brand: 'Komatsu', models: ['PC50MR', 'PC138', 'PC210'] },
  { category: 'excavadora-de-cadenas', brand: 'Volvo CE', models: ['ECR145E', 'EC220E'] },
  { category: 'excavadora-de-cadenas', brand: 'Hitachi', models: ['ZX130', 'ZX200'] },
  { category: 'excavadora-de-cadenas', brand: 'JCB', models: ['8085', 'JS220'] },
  { category: 'excavadora-de-cadenas', brand: 'Liebherr', models: ['R 313', 'R 926'] },
  { category: 'excavadora-de-cadenas', brand: 'Case CE', models: ['CX210D'] },
  { category: 'excavadora-de-cadenas', brand: 'Kubota', models: ['U55', 'KX080'] },

  // ScissorLift
  { category: 'plataforma-elevadora-articulada-telescopica-tijera', brand: 'JLG', models: ['2646ES', '3246ES', '4045R'] },
  { category: 'plataforma-elevadora-articulada-telescopica-tijera', brand: 'Genie', models: ['GS-2646', 'GS-3246', 'GS-4047'] },
  { category: 'plataforma-elevadora-articulada-telescopica-tijera', brand: 'Skyjack', models: ['SJIII 3226', 'SJIII 4740'] },
  { category: 'plataforma-elevadora-articulada-telescopica-tijera', brand: 'Haulotte', models: ['Compact 12', 'Optimum 8'] },

  // SkidSteerLoader
  { category: 'minicargadora-skid-steer', brand: 'Bobcat', models: ['S650', 'S770', 'T770'] },
  { category: 'minicargadora-skid-steer', brand: 'Caterpillar', models: ['262D3', '289D'] },
  { category: 'minicargadora-skid-steer', brand: 'Case CE', models: ['SV280', 'TV380'] },
  { category: 'minicargadora-skid-steer', brand: 'New Holland', models: ['L228', 'C238'] },
  { category: 'minicargadora-skid-steer', brand: 'JCB', models: ['155', '190T'] },
  { category: 'minicargadora-skid-steer', brand: 'Kubota', models: ['SSV65', 'SVL75-2'] },

  // Dumper
  { category: 'dumper-articulado', brand: 'Wacker Neuson', models: ['DT10', 'DW15', 'DW60'] },
  { category: 'dumper-articulado', brand: 'Thwaites', models: ['Alldrive 1', 'Alldrive 6-tonne'] },
  { category: 'dumper-articulado', brand: 'Ausa', models: ['D 150', 'D 601'] },
  { category: 'dumper-articulado', brand: 'Terex', models: ['TA6'] },
  { category: 'dumper-articulado', brand: 'Barford', models: ['SXR6000'] },
];

export const getMachineryBrandsForCategory = (category?: string): string[] =>
  category ? MACHINERY_BRANDS_SEED.filter((seed) => seed.category === category).map((seed) => seed.brand) : [];

// Brand match is case-insensitive since the field stays free text -- a host
// (or this same AutoComplete's own free typing) may not match the seed's
// exact casing.
export const getMachineryModelsForBrand = (category: string | undefined, brand: string | undefined): string[] => {
  if (!category || !brand) return [];
  const normalizedBrand = brand.trim().toLowerCase();
  const seed = MACHINERY_BRANDS_SEED.find((s) => s.category === category && s.brand.toLowerCase() === normalizedBrand);
  return seed?.models ?? [];
};
